import { projectDataType } from ".";

const icosaTotemsData: projectDataType = {
  path: "icosatotems",
  title: "Icosa Totems, Death Leaves Cans of Shaving Cream Half Used",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964765/Art-Site/IcosaTotems/icosa-1.png",
  description:
    "Music video for the song Death Leaves Cans of Shaving Cream Half Used, by ambient musician Richard Cruz.",
  videos: ["https://vimeo.com/126341381"],
  year: 2015,
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964765/Art-Site/IcosaTotems/icosa-1.png",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964760/Art-Site/IcosaTotems/screen_shot_2016-03-10_at_65833_pm_iyyh7q.jpg",
  ],
};

export default icosaTotemsData;
